import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//Pages
import Homepage from "../pages/Homepage";
import AboutFarmerPage from "../pages/AboutFarmerPage";

// ScrollToTop
import ScrollToTop from "../features/LoadingInfo/ScrollToTop";

export default function AppRouter() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <ScrollToTop />
          <Homepage />
        </Route>
        <Route path="/farmer/:idFarmer" exact>
          <ScrollToTop />
          <AboutFarmerPage />
        </Route>
      </Switch>
    </Router>
  );
}
